export default "__VITE_ASSET__CUyBNQ6f__"